<template>
	<div>
		<div>您是否要{{StoreIsSignIn ? '签出' : '签入'}}软电话</div>
		<br />
		<div style="text-align: right;">
			<el-button @click="handleSignOperate('签入', '内网签入')" v-if="!StoreIsSignIn && ['0', '2'].includes(StoreAgentInfo.isPublic)" :loading="loading" size="mini" type="primary">内网签入</el-button>
			<el-button @click="handleSignOperate('签入', '外网签入')" v-if="!StoreIsSignIn && ['1', '2'].includes(StoreAgentInfo.isPublic)" :loading="loading" size="mini" type="primary">外网签入</el-button>
			<el-button @click="handleSignOperate('签出')" v-if="StoreIsSignIn" :loading="loading" size="mini" type="primary">签出</el-button>
			<el-button @click="$emit('signClose')" size="mini">取消</el-button>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
	props: ['sipDriver'],
	computed: {
		...mapGetters([
			'userInfo',
			'StoreAgentInfo',
			'StoreIsSignIn',
		])
	},
	data() {
		return {
			loading: false,
		}
	},
	methods: {
		...mapMutations({
			'SET_SOFT_PHONE_IN_MSG': 'telService/SET_SOFT_PHONE_IN_MSG',
			'SET_IS_SIGN_IN':'telService/SET_IS_SIGN_IN',
			'SET_IS_IDLE': 'telService/SET_IS_IDLE',
			'SET_IS_BUSY': 'telService/SET_IS_BUSY',
			'SET_IS_CALL': 'telService/SET_IS_CALL',
			'SET_IS_ANSWER': 'telService/SET_IS_ANSWER',
			'SET_IS_KEEP': 'telService/SET_IS_KEEP',
			'SET_IS_BUSY_REASON': 'telService/SET_IS_BUSY_REASON'
		}),
		handleSignOperate(type, category) {
			this.loading = true;
			if(type === '签入') {
				// ! 签入软电话
				this.$api.apiPostCallSignIn({
					agentName: this.userInfo?.agentCode, 
					agentContact: this.userInfo?.deviceCode
				}).then(response => {
					if(response.errcode != 0) {
						this.SET_SOFT_PHONE_IN_MSG({
							msg: `签入失败`, 
							data: {
								errmsg: response?.errmsg
							}
						});
						this.loading = false;
						return;
					};
					setTimeout(() => {
						this.$api.apiGetAgentStatus({
							projectCode: this.userInfo?.brandIdentify,
							agentCode: this.userInfo?.agentCode
						}).then(res => {
							if(res.errcode != 0) {
								this.SET_SOFT_PHONE_IN_MSG({
									msg: `签入接口成功 - 状态查询接口失败`, 
									data: {
										errmsg: res?.errmsg
									}
								});
								this.loading = false;
								return;
							};
							this.sipDriver._init(category).then(() => {
								this.SET_IS_SIGN_IN({
									StoreIsSignIn: true, 
									StoreSingInCategory: category
								});
								if(res.data?.[0]?.['state'] === '置闲') {
									this.SET_IS_IDLE(true);
									this.SET_IS_BUSY({
										StoreIsBusy: false, 
										StoreIsBusyReason: `置闲`
									});
								}
								if(res.data?.[0]?.['state'] === '置忙') {
									// this.SET_IS_IDLE(true);
									// this.SET_IS_BUSY_REASON(res.data?.[0]?.['state']);
								}
								this.$emit('signClose');
								this.loading = false;
								this.$message.success({message: `软电话已签入`, offset: 70});
								this.SET_SOFT_PHONE_IN_MSG({
									msg: `软电话已签入`, 
									data: {
										category: category
									}
								});
							}).catch(err => {
								this.$emit('signClose');
								this.loading = false;
								this.$message.error({message: `软电话签入失败`, offset: 70});
								this.SET_SOFT_PHONE_IN_MSG({
									msg: `软电话签入失败`, 
									data: {
										err: err
									}
								});
							});
						}).catch(() => {
							this.loading = false;
						});
					}, 200);
				}).catch(() => {
					this.loading = false;
				});
			} else {
				// ! 签出软电话
				this.$api.apiPostCallSignOut({agentName: this.userInfo?.agentCode}).then(response => {
					if(response.errcode != 0) {
						this.SET_SOFT_PHONE_IN_MSG({
							msg: `签出失败`, 
							data: {
								errmsg: response.errmsg
							}
						});
						this.loading = false;
						return;
					};
					localStorage.removeItem('tel-service-agent-info');
					this.SET_IS_SIGN_IN({
						StoreIsSignIn: false, 
						StoreSingInCategory: ''
					});
					this.SET_IS_IDLE(false);
					this.SET_IS_BUSY({
						StoreIsBusy: false, 
						StoreIsBusyReason: ''
					});
					this.SET_IS_CALL(false);
					this.SET_IS_ANSWER(false);
					this.SET_IS_KEEP(false);
					this.sipDriver._stop();
					this.loading = false;
					this.$emit('signClose');
					this.$message.success({message: `软电话已签出`, offset: 70});
					this.SET_SOFT_PHONE_IN_MSG({
						msg: `软电话已签出`
					});
				}).catch(() => {
					this.loading = false;
				});
			}
		}
	}
}
</script>